module.exports = __webpack_public_path__ + "img/Flag_of_Zimbabwe.4b02de48.svg";